import React from 'react';
import { GridItem, Stack, cn } from '@guestyci/arc';

const ContentBlock = ({ children, hasStepper = false }) => {
  const mobileRow = hasStepper ? 3 : 2;
  const desktopRow = hasStepper ? 2 : 1;

  return (
    <GridItem
      gridColumnStart={{ xs: 1, md: 1, lg: 1 }}
      gridRowStart={{ xs: mobileRow, lg: desktopRow }}
      className={cn(
        'lg:gst-flex lg:gst-items-center lg:gst-justify-center lg:gst-pb-16',
        hasStepper ? 'gst-pt-3 lg:gst-pt-14' : 'lg:gst-pt-16',
      )}
    >
      <Stack
        direction="column"
        className="gst-w-full"
        style={{ maxWidth: 420 }}
      >
        {children}
      </Stack>
    </GridItem>
  );
};

export default ContentBlock;
